import { CodeBase } from "./_codeBase";

/**
 * 進捗表通常の列区分
 */
export class ProgressColumnType extends CodeBase<ProgressColumnType>
{
    /** 取込区分 "01", "追加" */
    public static readonly ADDED: ProgressColumnType = new ProgressColumnType("01", "追加");
    /** 取込区分 "02", "取込" */
    public static readonly EDITED: ProgressColumnType = new ProgressColumnType("02", "変更");
    /** 取込区分 "03", "削除" */
    public static readonly DELETED: ProgressColumnType = new ProgressColumnType("03", "削除");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ProgressColumnType[] {
        return [
            ProgressColumnType.ADDED,
            ProgressColumnType.EDITED,
            ProgressColumnType.DELETED,
        ];
    }
}
